import { defineStore } from 'pinia';
import { parseToRgb } from 'polished';
import { ColorSchema } from '@/types/api/Business/ColorSchema';

export const useThemeStore = defineStore('theme', {
  state: () => ({
    // Store the reactive theme properties
    primaryColor: '#1d1e19',
    primaryText: '#ffffff',
  }),
  actions: {
    setThemeFromSupplier(cs?: Iterable<ColorSchema> | null) {
      const list = Array.from(cs ?? []);

      const textHex  = list.find(c => c.schemaType === 'TEXT')?.hexCode  ?? '#FFFFFF';
      const colorHex = list.find(c => c.schemaType === 'COLOR')?.hexCode ?? '#000000';

      this.primaryColor = colorHex;
      this.primaryText = textHex;
    },
  },
    getters: {
      // This getter converts the hex color to an RGB object
      primaryColorRgb: (state) => {
        const rgb = parseToRgb(state.primaryColor);
        return `${rgb.red}, ${rgb.green}, ${rgb.blue}`;
      },
  },
});